// removed by extract-text-webpack-plugin
module.exports = {"main-container":"_2eZot2QUznvN1Ox8b_ikp1","qr":"_1Ysb2I-AUkHIU9-3cL33HC","logo":"_2PpGpzrAVrM7Bl9-NlnFEB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/WeChat.scss
// module id = 1212
// module chunks = 47